"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EARLY_RISKY_REVERSAL_UNBLOCK_MINIMUM_PAYMENT_FLOOR_DOLLARS = void 0;
/**
 * Floor for the qualifying ACH/wire payment amount that unblocks an early risky-return-code reversal account
 * https://www.figma.com/design/dvgMX3bxggDTzRT99DkoIP/Payment-Reversal?node-id=2277-6222&m=dev
 */
exports.EARLY_RISKY_REVERSAL_UNBLOCK_MINIMUM_PAYMENT_FLOOR_DOLLARS = 25;
